export default "__VITE_ASSET__aeb69794__"